import React from 'react';
import { Heart, CalendarDays, AlertCircle } from 'lucide-react';

const BenefitsSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  benefitTypes
}) => {
  // Если не выбрана ни одна льгота и не включена рассрочка, не отображаем секцию
  if (!formData.applyBenefits && !formData.installmentPlan) return null;

  return (
    <div className="mb-6 bg-purple-50 dark:bg-purple-900/20 p-4 rounded-lg border border-purple-200 dark:border-purple-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Heart className="w-5 h-5 mr-2 text-purple-500" />
        Льготы и рассрочка оплаты госпошлины
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Льготы по уплате госпошлины */}
        {formData.applyBenefits && (
          <div className="col-span-full md:col-span-1">
            <label htmlFor="benefitType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Категория льготы
            </label>
            <select
              id="benefitType"
              name="benefitType"
              value={formData.benefitType}
              onChange={handleInputChange}
              className={`form-select w-full ${errors.benefitType ? 'input-error' : ''}`}
            >
              {benefitTypes.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </select>
            {errors.benefitType && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.benefitType}
              </p>
            )}
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              {benefitTypes.find(type => type.id === formData.benefitType)?.description || 'Выберите категорию льготы'}
            </p>
          </div>
        )}

        {/* Рассрочка оплаты */}
        {formData.installmentPlan && (
          <div className="col-span-full md:col-span-1">
            <label htmlFor="installmentMonths" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <CalendarDays className="w-4 h-4 mr-2 text-purple-500" />
              Срок рассрочки (месяцев)
            </label>
            <input
              type="number"
              id="installmentMonths"
              name="installmentMonths"
              value={formData.installmentMonths}
              onChange={handleInputChange}
              min="1"
              max="36"
              className={`form-input w-full ${errors.installmentMonths ? 'input-error' : ''}`}
              placeholder="Количество месяцев"
            />
            {errors.installmentMonths && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.installmentMonths}
              </p>
            )}
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              При рассрочке 50% госпошлины уплачивается сразу, остальное - в течение указанного срока
            </p>
          </div>
        )}
      </div>

      <div className="mt-4 p-3 bg-purple-100 dark:bg-purple-900/40 rounded-lg flex items-start">
        <AlertCircle className="w-5 h-5 text-purple-700 dark:text-purple-300 mt-0.5 mr-3 flex-shrink-0" />
        <div>
          <h4 className="text-sm font-medium text-purple-700 dark:text-purple-300 mb-1">
            Важная информация
          </h4>
          <p className="text-xs text-purple-600 dark:text-purple-400">
            Решение о предоставлении отсрочки, рассрочки или освобождения от уплаты госпошлины принимается судом
            на основании ходатайства с приложением документов, подтверждающих тяжелое финансовое положение или особый статус.
            Данный расчет носит справочный характер и основан на типовых ставках льгот.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BenefitsSection;